import { Alert, Button, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { COLOR_PRIMARY_2, COLOR_SUCCESS_1, COLOR_SUCCESS_1_HOVER, SIDEBAR_COLOR } from 'src/utils/colors';
import { getListingIDFromURL, isValidListingId } from '../../OverviewPage/helper';
import { callApi } from 'src/core/callApi';
import { IndividualListingModalV2 } from 'src/App/Dashboards/Market/Modals';
import {
  processIndividualListingData,
  trackUserSearchedIndividualListingThroughLink,
} from 'src/utils/functions';

const SearchListings = ({
  currency,
  setSubscriptionModalOpen,
  handleOnSampleClick,
  subscriptionModalOpen,
  openDemoBookingForm,
  setDemoFormHeadingFor,
  user,
  matches,
  resetCurrencyToDefault,
}) => {
  const [listingIdentifier, setListingIdentifier] = useState<string>('');
  const [listingData, setListingData] = useState<any>();
  const [error, setError] = useState<boolean>(false);
  const [isloading, setIsLoading] = useState<boolean>(false);
  const [showListingNotAvailiable, setShowListingNotAvailiable] = useState<boolean>(false);

  useEffect(() => {
    resetCurrencyToDefault();
  }, []);

  const getListingData = async listingID => {
    setIsLoading(true);
    setError(false);
    setShowListingNotAvailiable(false);
    const URL = 'https://8q15spida4.execute-api.us-east-2.amazonaws.com/default/getListingDetails';
    const config = {
      queryParams: {
        listingID: listingID,
        apiType: 'v5',
        marketID: ''
      },
    };

    try {
      const resp = await callApi(URL, config, true, false, '', 'GET', true);

      if (resp.error) {
        if (resp.error === 'Listing not available') {
          setShowListingNotAvailiable(true);
        } else {
          setError(true);
        }
        setIsLoading(false);
        return;
      }

      let listingData = resp?.message;
      let processedData = processIndividualListingData(listingData);
      setListingData(processedData);
      setIsLoading(false);
    } catch (error) {
      setError(true);
      setIsLoading(false);
    }
  };

  const saveListingIdentifier = () => {
    let ListingID: string = '';
    if (listingIdentifier.startsWith('http://') || listingIdentifier.startsWith('https://')) {
      ListingID = getListingIDFromURL(listingIdentifier);
      getListingData(ListingID);
    } else {
      if (isValidListingId(listingIdentifier)) {
        ListingID = listingIdentifier;
        getListingData(ListingID);
      } else {
        setError(true);
        return;
      }
    }
    trackUserSearchedIndividualListingThroughLink();
  };

  const handleSubmit = e => {
    e.preventDefault();
    saveListingIdentifier();
  };

  return (
    <Grid
      container
      xs={12}
      sx={{
        backgroundColor: SIDEBAR_COLOR,
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Grid
        container
        itemID=""
        sx={{
          borderRadius: '8px',
          width: matches ? '80%' : '60%',
        }}
      >
        {listingData && (
          <IndividualListingModalV2
            open={true}
            onClose={() => setListingData(null)}
            data={listingData}
            currency={currency}
            isDisabled={user.subscriptionPlan != 'starter' ? false : true}
            setSubscriptionModalOpen={setSubscriptionModalOpen}
            handleOnSampleClick={handleOnSampleClick}
            subscriptionModalOpen={subscriptionModalOpen}
            isEstimator={false}
            openDemoBookingForm={openDemoBookingForm}
            setDemoFormHeadingFor={setDemoFormHeadingFor}
          />
        )}
        <Grid item xs={12} sx={{ height: '50px', padding: '10px 0px' }}>
          <Typography variant="h5" sx={{ fontWeight: 500, color: COLOR_PRIMARY_2 }}>
            Enter Airbnb Listing ID or Airbnb URL:
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <Grid container spacing={0}>
            <Grid item xs={9} sx={{ marginTop: matches ? '30px' : '10px' }}>
              <TextField
                id="outlined-basic"
                label="https://www.airbnb.com/rooms/673529303?locale=en........"
                variant="outlined"
                fullWidth
                value={listingIdentifier}
                onChange={e => {
                  setListingIdentifier(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '20px 0px 0px 20px',
                  },
                  height: '40px',
                }}
              />
            </Grid>
            <Grid item xs={3} sx={{ marginTop: matches ? '30px' : '10px' }}>
              <Button
                variant="contained"
                fullWidth
                disabled={listingIdentifier == ''}
                type="submit"
                sx={{
                  fontSize: matches ? '10px' : '20px',
                  background: COLOR_SUCCESS_1,
                  padding: '5px 10px',
                  color: '#ffffff',
                  height: '56px',
                  borderRadius: '0px 20px 20px 0px',
                  '&:hover': { backgroundColor: COLOR_SUCCESS_1_HOVER },
                }}
                // onClick={saveListingIdentifier}
              >
                {isloading ? (
                  <CircularProgress size={30} sx={{ color: SIDEBAR_COLOR }} />
                ) : (
                  'Search'
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
        {showListingNotAvailiable && (
          <Grid item xs={12} sx={{ marginTop: '10px' }}>
            {' '}
            <Alert severity="warning" sx={{ padding: '10px' }}>
              We couldn't locate the listing. It may be due to an incorrect ID or URL, an inactive
              listing, or a recently added listing. Please verify the information and try again.
            </Alert>
          </Grid>
        )}
        {error && (
          <Grid item xs={12} sx={{ marginTop: '10px' }}>
            {' '}
            <Alert severity="error" sx={{ padding: '10px' }}>
              Please Enter a valid URL/Listing Id
            </Alert>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default SearchListings;
